import React, { useState, useEffect, useRef } from 'react'
import { Trans, Button } from '../../atoms'
import { Form, Formik, FieldArray } from 'formik'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import FormFile from '../../atoms/FormFile/FormFile'
import { api } from '../../../utils'
import { CARICAMENTOLOGHIORDINE } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import Alert from '../../atoms/Alert/Alert'
import { AlertTriangleLine, Info } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import { AnteprimaLogo } from '../../molecules'
import * as Sentry from '@sentry/browser'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

export const UploadLoghi = ({
  personalizzazione,
  personalizzazioni_righe_equivalenti,
  ordine,
  handleUploadLogo,
  checkStessoLogo,
}) => {
  const t = useTrans()
  const router = useRouter()
  const lang = router.query.lang

  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [uploading, setUploading] = useState(false)

  const onLogoUpload = async (values) => {
    setUploading(true)

    let formData = new FormData()
    formData.append('logo', values.file)

    try {
      const response = await api.put(
        `${CARICAMENTOLOGHIORDINE}${personalizzazione.id}/`,
        formData,
        {
          params: {
            lang,
            ordine_id: ordine.id,
            personalizzazioni_equivalenti_ids: personalizzazioni_righe_equivalenti
              .filter((pers) => pers.id !== personalizzazione.id)
              .map((pers) => pers.id),
          },
        }
      )
      const data = await response.data

      setLogoUrl(data.logo_url)
      setNomeLogo(values.file.name)

      handleUploadLogo(personalizzazione.id, true)

      setErrorMessage('')
      setSuccessMessage('Logo caricato con successo')
    } catch (error) {
      setSuccessMessage('')
      setErrorMessage('Errore nel caricamento del logo')
      Sentry.captureException(error)
    }
    setUploading(false)
  }

  const [nomeLogo, setNomeLogo] = useState(personalizzazione.logo_name)
  const [logoUrl, setLogoUrl] = useState(personalizzazione.logo_url)

  return (
    <div>
      {!checkStessoLogo && (
        <div className="fp-upload-loghi">
          {(errorMessage || successMessage) && (
            <div className="fp-upload-bozza__alerts">
              {errorMessage && (
                <Alert placeholder={errorMessage} variant="error" icon={<AlertTriangleLine />} />
              )}
              {successMessage && (
                <Alert placeholder={successMessage} variant="info" icon={<Info />} />
              )}
            </div>
          )}
          <Formik
            initialValues={{
              file: null,
            }}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              onLogoUpload(values).then(() => {
                resetForm({
                  errors: {
                    file: 'Required',
                  },
                })
              })
            }}
            validateOnChange={true}
            validateOnMount={true}
            validate={(values) => {
              const errors = {}

              if (!values.file) {
                errors.file = 'Required'
              }

              return errors
            }}
          >
            {({ values, handleChange, errors, isValid, setFieldValue }) => (
              <Form>
                <div className="fp-upload-loghi__fieldsets">
                  <div>
                    <FormField label="File logo">
                      <FormFile
                        placeholder={values.file?.name ? values.file.name : t('Carica file')}
                        id="file"
                        name="file"
                        onChange={(event) => setFieldValue('file', event.target.files[0])}
                      />
                    </FormField>
                  </div>
                </div>
                <div>
                  <Button
                    type="submit"
                    label="Upload"
                    variant="primary"
                    size="large"
                    disabled={!isValid || uploading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
      <div className="fp-logo-caricato">
        <p className="fp-logo-caricato__content">
          <span>
            <Trans chiave="Logo: " />
          </span>
          {checkStessoLogo ? (
            <span>
              <Trans chiave="Stesso logo" />
            </span>
          ) : logoUrl ? (
            <span>{nomeLogo}</span>
          ) : (
            <span>
              <Trans chiave="Nessun logo caricato" />
            </span>
          )}
        </p>
        {logoUrl && !checkStessoLogo && (
          <div className="fp-logo-caricato__link">
            <AnteprimaLogo src={logoUrl} filename={nomeLogo} className="fp-logo-caricato__image" />
          </div>
        )}
      </div>
    </div>
  )
}
